import {
    HtmlComponent as SourceHtmlComponent,
    HIGH_PRIORITY_ELEMENTS,
} from 'SourceComponent/Html/Html.component';
import React from 'react';
import './Html.override.style';
import { setLoadedFlag } from '@scandipwa/scandipwa/src/util/Request/LowPriorityLoad';
import domToReact from 'html-react-parser/lib/dom-to-react';
import Link from 'Component/Link';

export {
    HIGH_PRIORITY_ELEMENTS,
};

export class HtmlComponent extends SourceHtmlComponent {
    parserOptions = {
        // eslint-disable-next-line react/no-unstable-nested-components
        replace: (domNode) => {
            const {
                data,
                name: domName,
                attribs: domAttrs,
                parent,
                next,
                children = [],
            } = domNode;

            if (!parent && !next && !this.lastBlock) {
                if (children.length) {
                    this.lastBlock = this.getLastRenderElement(children[children.length - 1]);
                } else {
                    this.lastBlock = this.getLastRenderElement(domNode);
                }
            }

            if (this.lastBlock === domNode && !this.isPriorityLoading) {
                setLoadedFlag();
            }

            // Let's remove empty text nodes
            if (data && !data.replace(/\u21b5/g, '').replace(/\s/g, '').length) {
                return <></>;
            }

            const rule = this.rules.find((rule) => {
                const { query: { name, attribs = [] } } = rule;

                if (name && domName && name.indexOf(domName) !== -1) {
                    return true;
                }

                if (attribs && domAttrs) {
                    for (let i = 0; i < attribs.length; i++) {
                        const attrib = attribs[i];

                        if (typeof attrib === 'object') {
                            const queryAttrib = Object.keys(attrib)[0];

                            if (Object.prototype.hasOwnProperty.call(domAttrs, queryAttrib)) {
                                return domAttrs[queryAttrib].match(Object.values(attrib)[0]);
                            }
                        } else if (Object.prototype.hasOwnProperty.call(domAttrs, attrib)) {
                            return true;
                        }
                    }
                }

                return false;
            });

            if (rule) {
                const { replace } = rule;

                if (this.isPriorityLoading) {
                    return (
                        <>
                            {/* // <AfterPriority fallback={ <div style={ { height: '100vh' } } /> }> */}
                            {replace.call(this, domNode)}
                            {/* // </AfterPriority> */}
                        </>
                    );
                }

                if (rule.query.name.some((name) => HIGH_PRIORITY_ELEMENTS.includes(name)) && !this.isPriorityLoading) {
                    this.isPriorityLoading = true;
                }

                return replace.call(this, domNode);
            }
        },
    };

    componentDidMount(prevProps) {
        // for accrodian container toggle bar
        const accordianContainer = document.querySelectorAll('.accordion-contianer');

        if (accordianContainer.length > 0) {
            for (let i = 0; i < accordianContainer?.length; i++) {
                accordianContainer[i].onclick = function () {
                    const active = this.classList.toggle("active");
                    const acco = this.querySelector('.accordion');
                    const panel = this.querySelector('.panel');

                    if (active) {
                        panel.style.display = "block";
                        acco.classList.add("active")
                    } else {
                        panel.style.display = "none";
                        acco.classList.remove("active")
                    }
                };
            }
        }

        // for faq ite,s toggle bar
        const faqItems = document.getElementsByClassName('faq-item');

        if (faqItems.length > 0) {
            for (let i = 0; i < faqItems?.length; i++) {
                faqItems[i].onclick = function () {
                    const active = this.classList.toggle("active");
                };
            }
        }

        // for homepage appointment popup
        const bookappoinetment = document.getElementsByClassName("CategoryLandingPage-BookAppointBtn");

        if (bookappoinetment?.length) {
            bookappoinetment[0].onclick = function () {
                const bookappoinetmentmodel = document.getElementById("appointment-popup");

                if (bookappoinetmentmodel) {
                    bookappoinetmentmodel.style.display = "flex";

                    const bookappoinetmentmodelcloseicon = document.getElementsByClassName("appointment_closeIcon");
                    if (bookappoinetmentmodelcloseicon?.length > 0) {
                        bookappoinetmentmodelcloseicon[0].onclick = function () {
                            bookappoinetmentmodel.style.display = "none";
                        }
                    }
                }
            }
        }

        const bookappoinetment1 = document.getElementsByClassName("BookAnaappointMent-Button");

        if (bookappoinetment1?.length) {
            bookappoinetment1[0].onclick = function () {
                const bookappoinetmentmodel = document.getElementById("appointment-popup");

                if (bookappoinetmentmodel) {
                    bookappoinetmentmodel.style.display = "flex";

                    const bookappoinetmentmodelcloseicon = document.getElementsByClassName("appointment_closeIcon");
                    if (bookappoinetmentmodelcloseicon?.length > 0) {
                        bookappoinetmentmodelcloseicon[0].onclick = function () {
                            bookappoinetmentmodel.style.display = "none";
                        }
                    }
                }
            }
        }
    }

    /**
     * Replace links to native React Router links
     * @param  {{ attribs: Object, children: Array }}
     * @return {void|JSX} Return JSX if link is allowed to be replaced
     * @memberof Html
     */
    replaceLinks({ attribs, children }) {
        const { href, ...attrs } = attribs;

        if (href) {
            const isAbsoluteUrl = (value) => /^(?:[a-z]+:)?\/\//i.test(value);
            const isSpecialLink = (value) => /^(sms|tel|mailto):/i.test(value);
            const idHash = (value) => /^#/.test(value);

            if (!isAbsoluteUrl(href) && !isSpecialLink(href) && !idHash(href)) {
                return (
                    <Link
                        onClick={this.scrollToTopFunction}
                        {...this.attributesToProps({ ...attrs, to: href })}
                    >
                        {domToReact(children, this.parserOptions)}
                    </Link>
                );
            }

            if (idHash(href)) {
                return (
                    <a
                        href={href}
                        rel="noreferrer"
                        {...attrs}
                    >
                        {domToReact(children, this.parserOptions)}
                    </a>
                );
            }
        }

        return (<a
            href={href}
            target='_blank'
            rel="noreferrer"
            {...attrs}
        >
            {domToReact(children, this.parserOptions)}
        </a>);
    }
}

export default HtmlComponent;
